import { Routes } from "@angular/router";
import { anonymousGuard } from "./guards/anonymous.guard";
import { authGuard } from "./guards/auth.guard";

export const routes: Routes = [
  { path: "", redirectTo: "auth/login", pathMatch: "full" },
  {
    path: "",
    loadChildren: () =>
      import("./authentication/authentication-routes").then(
        (authenticationRoutes) => authenticationRoutes.routes
      ),
    canActivate: [anonymousGuard],
  },

  {
    path: "",
    canActivate: [authGuard],
    loadChildren: () =>
      import(
        "./components/form-builder-template/form-builder-template.routes"
      ).then((m) => m.routes),
  },
];
